import * as R from 'ramda';
import { Endpoints } from '../../../../core/api/endpoints';
import { ApiReducer, makeApiReducer, makeApiAction, makeRsaaTypes } from '../../../../core/api/rsaa';
import { addError, noLoadingNoError, addLoading, getLoading } from '../../../../core/api/module';
import { ActionType } from '../../../../core/redux/actionType';
import { updateAction } from '../module';


const KEY_ACTION = ActionType.UpdateDevPlanActionStatusRequest;
const ACTIONS    = [
  ActionType.UpdateDevPlanActionStatusRequest,
  ActionType.UpdateDevPlanActionStatusResponse,
  ActionType.UpdateDevPlanActionStatusError,
];


type Payload = undefined;
type Meta = {
  projectId: number;
  devItemId: number;
  devActionId: number;
  statusId: number;
};


/**
 * Dispatch this action to change an action's status
 */
export const updateDevPlanActionStatusAction = (
  projectId: number,
  devItemId: number,
  devActionId: number,
  statusId: number,
) => makeApiAction<Payload, Meta>({
  method:   'POST',
  endpoint: Endpoints.UpdateDevPlanActionStatus,
  headers:  { 'content-type': 'application/json' },
  body:     state => JSON.stringify({
    devActionId,
    status: statusId,
    projectId: projectId,
    participantId: state.auth.currentUser?.personId ?? 0,
    languageId: state.locale.lang.languageId,
  }),
  types:    makeRsaaTypes<Payload, Meta>(ACTIONS, { projectId, devItemId, devActionId, statusId }),
  bailout:  state => !!getLoading(state, KEY_ACTION, devActionId),
});


const reducer: ApiReducer<Payload, Meta> = (state, action, errorMsg, isLoading, payload) => {
  if (isLoading) {
    return addLoading(state, KEY_ACTION, action.meta.devActionId);
  }

  if (errorMsg) {
    return addError(state, KEY_ACTION, errorMsg, action.meta.devActionId);
  }

  const successState = noLoadingNoError(state, KEY_ACTION, action.meta.devActionId);

  return updateAction(
    action.meta.devItemId,
    action.meta.devActionId,
    R.assoc('status', action.meta.statusId),
    successState,
  );
};


export const updateDevPlanActionStatusReducer = makeApiReducer<Payload, Meta>(ACTIONS, KEY_ACTION, reducer);
